var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade modalMobileFull",
      attrs: {
        id: "modalUserNav",
        role: "dialog",
        tabindex: "-1",
        onclick: "$('#modalUserNav').modal('hide')",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog modal-md" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c(
            "div",
            { staticClass: "modal-content-mobileFull bg-grey3 radius-18" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modal-main bg-white pos-relative zindex-0" },
                [
                  _vm.shop
                    ? _c("ul", { staticClass: "modal-user-nav py-20" }, [
                        _c("li", [
                          _c(
                            "a",
                            {
                              staticClass: "flex-start-center px-20 py-10",
                              attrs: {
                                href: _vm.shop.ShopId + "/client/orders",
                              },
                            },
                            [
                              _c("i", { staticClass: "fie-icon_receipt" }),
                              _c("span", [_vm._v("Mes Commandes")]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c(
                            "a",
                            {
                              staticClass: "flex-start-center px-20 py-10",
                              attrs: {
                                href: _vm.shop.ShopId + "/client/details",
                              },
                            },
                            [
                              _c("i", { staticClass: "fie-icon_fingerprint" }),
                              _c("span", [_vm._v("Mon profil")]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c(
                            "a",
                            {
                              staticClass: "flex-start-center px-20 py-10",
                              attrs: {
                                href: _vm.shop.ShopId + "/client/details",
                              },
                            },
                            [
                              _c("i", { staticClass: "fie-icon_pin" }),
                              _c("span", [_vm._v("Mes Adresses")]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("li", [
                          _c(
                            "a",
                            {
                              staticClass: "flex-start-center px-20 py-10",
                              attrs: {
                                href: _vm.shop.ShopId + "/client/details",
                              },
                            },
                            [
                              _c("i", { staticClass: "fie-icon_credit-card" }),
                              _c("span", [_vm._v("Mes Cartes")]),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.fidCard
                          ? _c("li", [
                              _c(
                                "a",
                                {
                                  staticClass: "flex-start-center px-20 py-10",
                                  attrs: {
                                    href:
                                      _vm.shop.ShopId +
                                      "/client/details#fidelite",
                                  },
                                },
                                [
                                  _c("i", { staticClass: "fie-icon_offer" }),
                                  _c("span", [_vm._v("Ma fidélité")]),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "modal-bottom bg-white w-100 pos-sticky bottom-0 zindex-1 radius-18 shadow-4",
                },
                [
                  _vm.client
                    ? _c("div", { staticClass: "flex-start-center p-20" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "avatarLetters flex-center-center bg-grey3 radius-circle mr-10",
                          },
                          [
                            _c("span", { staticClass: "first" }, [
                              _vm._v(_vm._s((_vm.client.FirstName || "")[0])),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "last" }, [
                              _vm._v(_vm._s((_vm.client.LastName || "")[0])),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "w-100" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "fsize-16 text-bold color-grey1 text-capitalize text-truncate bottom-username",
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t" +
                                  _vm._s(_vm.client.FirstName) +
                                  " " +
                                  _vm._s(_vm.client.LastName) +
                                  "\n\t\t\t\t\t\t\t"
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex-between-end flex-wrap w-100" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "fsize-12 color-grey2 text-truncate mr-5",
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(_vm.client.Email) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "fsize-12 link-bo-danger pt-5",
                                  on: {
                                    click: function ($event) {
                                      return _vm.ClientService.logout()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\tDéconnexion\n\t\t\t\t\t\t\t\t"
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]
              ),
            ]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticClass:
          "modal-top bg-grey3 flex-between-start radius-18 radius-bottom-0 p-20 top-0 pos-sticky zindex-2",
      },
      [
        _c("div", [
          _c(
            "div",
            {
              staticClass:
                "modal-top--title fsize-18 color-grey1 text-bold text-uppercase radius-18 radius-bottom-0",
            },
            [_vm._v("\n\t\t\t\t\t\t\tMon Compte\n\t\t\t\t\t\t")]
          ),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "close rounded-btn display-1 px-10 bg-grey3",
            attrs: {
              type: "button",
              "aria-label": "Close",
              "data-dismiss": "modal",
            },
          },
          [
            _c(
              "span",
              {
                staticClass: "font-lato text-light",
                attrs: { "aria-hidden": "true" },
              },
              [_vm._v("×")]
            ),
          ]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }